export function shouldScrollToTop(
  content: Element | Window,
  url: string,
): boolean {
  const queryParams = url.split('?')[1];
  let params = new URLSearchParams(queryParams);
  const noScroll = params.get('noScroll');
  return content.scrollTo && noScroll !== 'true';
}
